import { useState, useEffect, SetStateAction, Dispatch } from "react";
import { Filters } from "./useFilters";

interface UseFilterStorageResult {
  filters: Filters;
  saveFilters: (newFilters: Filters) => void;
  clearFilters: () => void;
  setFilters: Dispatch<SetStateAction<Filters>>;
}

const useFilterStorage = (key: string): UseFilterStorageResult => {
  const [filters, setFilters] = useState<Filters>(() => {
    if (!key) return {};
    const savedFilters = localStorage.getItem(key);
    return savedFilters ? JSON.parse(savedFilters) : {};
  });

  useEffect(() => {
    // Save filters to local storage whenever they change
    localStorage.setItem(key, JSON.stringify(filters));
  }, [filters, key]);

  const saveFilters = (newFilters: Filters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...newFilters,
    }));
  };

  const clearFilters = () => {
    setFilters({});
  };

  return {
    filters,
    saveFilters,
    clearFilters,
    setFilters,
  };
};

export default useFilterStorage;
